"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamingRequest = void 0;
/**
 * @module botframework-streaming
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var httpContentStream_1 = require("./httpContentStream");
var subscribableStream_1 = require("./subscribableStream");
/**
 * The basic request type sent over Bot Framework Protocol 3 with Streaming Extensions transports, equivalent to HTTP request messages.
 */
var StreamingRequest = /** @class */ (function () {
    function StreamingRequest() {
        /**
         * List of associated streams.
         */
        this.streams = [];
    }
    /**
     * Creates a streaming request with the passed in method, path, and body.
     *
     * @param method The HTTP verb to use for this request.
     * @param path Optional path where the resource can be found on the remote server.
     * @param body Optional body to send to the remote server.
     * @returns On success returns a streaming request with appropriate status code and body.
     */
    StreamingRequest.create = function (method, path, body) {
        var request = new StreamingRequest();
        request.verb = method;
        request.path = path;
        if (body) {
            request.setBody(body);
        }
        return request;
    };
    /**
     * Adds a new stream attachment to this streaming request.
     *
     * @param content The Http content to include in the new stream attachment.
     */
    StreamingRequest.prototype.addStream = function (content) {
        if (!content) {
            throw new Error('Argument Undefined Exception: content undefined.');
        }
        this.streams.push(new httpContentStream_1.HttpContentStream(content));
    };
    /**
     * Sets the contents of the body of this streamingRequest.
     *
     * @param body The JSON text to write to the body of the streamingRequest.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    StreamingRequest.prototype.setBody = function (body) {
        if (typeof body === 'string') {
            var stream = new subscribableStream_1.SubscribableStream();
            stream.write(body, 'utf8');
            this.addStream(new httpContentStream_1.HttpContent({
                type: 'application/json; charset=utf-8',
                contentLength: stream.length,
            }, stream));
        }
        else if (typeof body === 'object') {
            this.addStream(body);
        }
    };
    return StreamingRequest;
}());
exports.StreamingRequest = StreamingRequest;
//# sourceMappingURL=streamingRequest.js.map